/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Icon } from 'components';
import { featureEnabled } from 'utils';
import { useBreakpoint } from 'hooks';
import TourListingContext from '../TourListingContext';
import { TourModalType } from '../types';
import ModalMobileHeader from '../TourSideNav/ModalMobileHeader';

const TourListingModalTitle: React.FC = () => {
  const { modalType, setModalType, resetSelectedTimes, setListingModalState } =
    useContext(TourListingContext);
  const { lg } = useBreakpoint();
  const showingModalTitle = `Showing Request`;
  if (modalType === TourModalType.LISTING) {
    if (!lg) {
      return (
        <ModalMobileHeader
          title="Listing Details"
          handleBackIconClick={() => setListingModalState(false)}
        />
      );
    }
    return <span>Listing Details</span>;
  }

  if (modalType === TourModalType.APPOINTMENT) {
    if (!lg) {
      return (
        <ModalMobileHeader
          title={showingModalTitle}
          handleBackIconClick={() => setListingModalState(false)}
        />
      );
    }
    return <span>{showingModalTitle}</span>;
  }
  // Else TourModalType.RESCHEDULE
  if (!lg) {
    return (
      <ModalMobileHeader
        title="Reschedule"
        handleBackIconClick={() => setListingModalState(false)}
      />
    );
  }
  return (
    <StyledFlexTitle>
      <StyledGoBack
        onClick={() => {
          setModalType(TourModalType.APPOINTMENT);
          resetSelectedTimes();
        }}
      >
        <Icon
          type="antdArrowLeftOutlined"
          height={14}
          width={14}
          color={'black'}
        />
      </StyledGoBack>
      Reschedule
    </StyledFlexTitle>
  );
};

export default TourListingModalTitle;

const StyledFlexTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledGoBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;

  &:hover {
    cursor: pointer;
  }
`;
